<nav id="sidebar" class="bg-dark text-white mt-3">
  <!-- SOLR - Search bar -->
  <!-- <div *ngIf="isMenuVisible('searchBar')" class="mt-4 input-group d-flex justify-content-center">
      <app-solr-autocomplete 
         ngbTooltip_= "Ricerca..."
         placeholder_= "Scrivi qualcosa..."
         placement_= "bottom"
         [resultFormatter_]="resultFormatter"
         [inputFormatter_]="inputFormatter"
         [filter]="solrCore"
         [btnSearch]="true"
         (selectedItemEvent)="selectedSearchItem($event)"
         (selectedItemClickEvent)="selectedSearchItemClick($event)">
      </app-solr-autocomplete>
   </div> -->

  <!-- Menu -->
  <ul class="list-unstyled scroll-list mt-4">
    <li class="border-bottom" *ngIf="isMenuVisible('home')">
      <a
        (click)="onMenuToggle()"
        href="#"
        routerLink="/mappa"
        [routerLinkActiveOptions]="{ exact: true }"
        routerLinkActive="active"
        >Home</a
      >
    </li>

    <!-- <li class="border-bottom" *ngIf="isMenuVisible('analisi_visibilita')">
         <a (click)="toggleSidebarAnalysis()" href="#" routerLink="/mappa/sidebar/analisi-visibilita"
            routerLinkActive="active">
            Analisi di Visibilità
         </a>
      </li> -->

    <li class="border-bottom" *ngIf="isMenuVisible('analisi')">
      <a
        (click)="toggleSidebarAnalysis()"
        href="#"
        routerLink="/mappa/sidebar/analisi"
        routerLinkActive="active"
      >
        Analisi
      </a>
    </li>
    <!-- <li class="border-bottom" *ngIf="isMenuVisible('gestione_analisi')">
         <a (click)="onMenuToggle()" href="#" routerLink="/gestione-analisi" routerLinkActive="active">
            Gestione Analisi
         </a>
      </li> -->
    <li class="border-bottom" *ngIf="isMenuVisible('ricerca_analisi')">
      <a
        (click)="toggleSidebarAnalysis()"
        href="#"
        routerLink="/mappa/sidebar/ricerca-analisi"
        routerLinkActive="active"
      >
        Ricerca Analisi
      </a>
    </li>
    <li class="border-bottom" *ngIf="isMenuVisible('gestione_analisi_massiva')">
      <a
        href="#"
        routerLink="/gestione-analisi-massiva"
        routerLinkActive="active"
      >
        Gestione Analisi Massiva
      </a>
    </li>

    <li class="border-bottom" *ngIf="isMenuVisible('analisi')">
      <a
        (click)="toggleSidebarAnalysis()"
        href="#"
        routerLink="/mappa/sidebar/legenda-analisi"
        routerLinkActive="active"
      >
        Legenda Analisi
      </a>
    </li>
    <li class="border-bottom" *ngIf="isMenuVisible('download')">
      <a
        href="#item"
        data-toggle="collapse"
        aria-expanded="false"
        class="dropdown-toggle"
        >Download Template</a
      >
      <ul class="collapse list-unstyled" id="item">
        <li class="border-top" *ngIf="isMenuVisible('empty_template')">
          <a
            class="btn text-left"
            role="button"
            (click)="download(emptyTemplatePath, EMPTY_FILENAME)"
            >Template Vuoto (.csv)</a
          >
        </li>

        <li class="border-top" *ngIf="isMenuVisible('example_template')">
          <a
            class="btn text-left"
            role="button"
            (click)="download(exampleTemplatePath, EXAMPLE_FILENAME)"
            >Template di Esempio (.csv)</a
          >
        </li>
        <li class="border-top" *ngIf="isMenuVisible('pixel_template')">
          <a
            class="btn text-left"
            role="button"
            (click)="download(pixelTemplatePath, EXAMPLE_PIXEL_FILENAME)"
            >Template Caricamento Pixel (.json)</a
          >
        </li>
      </ul>
    </li>
   
    <!-- EXAMPLE -->
    <!-- <li class="border-bottom"
          *ngIf="isMenuVisible('itemTest')">
         <a href="#item"
            data-toggle="collapse"
            aria-expanded="false"
            class="dropdown-toggle">Item</a>
         <ul class="collapse list-unstyled"
             id="item">
            <li class="border-top"
                *ngIf="isMenuVisible('subitemTest')">
               <a href="#"
                  [routerLink]="['/subitem']">Subitem</a>
            </li>
         </ul>
      </li> -->
  </ul>
</nav>
